import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { QuotaListReturnModel, } from '../models/models'

export class GetQuotaListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/GetQuotaList',
      requesterInfo,
    })
  }

  public async getQuotaList(): Promise<QuotaListReturnModel[]> {
    return await this.postAsync<QuotaListReturnModel[]>()
  }
}
